import { ref,  onMounted } from 'vue'

const THEME_STORAGE_KEY = 'salon-dashboard-theme'

// État global du thème
const currentTheme = ref(localStorage.getItem(THEME_STORAGE_KEY) || 'auto')
const isDark = ref(true)

export function useTheme() {
  // Détecter la préférence système
  const getSystemTheme = () => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }

  // Appliquer le thème sur le document
  const applyTheme = (theme) => {
    const effectiveTheme = theme === 'auto' ? getSystemTheme() : theme
    isDark.value = effectiveTheme === 'dark'

    if (isDark.value) {
      document.documentElement.classList.add('dark')
      document.documentElement.classList.remove('light')
    } else {
      document.documentElement.classList.add('light')
      document.documentElement.classList.remove('dark')
    }
  }

  // Changer le thème
  const setTheme = (theme) => {
    currentTheme.value = theme
    localStorage.setItem(THEME_STORAGE_KEY, theme)
    applyTheme(theme)
  }

  // Écouter les changements de préférence système
  const watchSystemTheme = () => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    const handler = () => {
      if (currentTheme.value === 'auto') {
        applyTheme('auto')
      }
    }

    // Nouvelle API
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handler)
    } else {
      // Fallback pour anciens navigateurs
      mediaQuery.addListener(handler)
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handler)
      } else {
        mediaQuery.removeListener(handler)
      }
    }
  }

  // Initialiser le thème
  onMounted(() => {
    applyTheme(currentTheme.value)
    watchSystemTheme()
  })

  return {
    currentTheme,
    isDark,
    setTheme,
    getSystemTheme
  }
}
